import {
  createContext,
  Dispatch,
  FC,
  ReactNode,
  useMemo,
  useReducer
} from 'react';
import { reducer } from './reducer';
import { AccountSelectionState } from './types';

const initialState: AccountSelectionState = {
  amounts: {
    from: undefined,
    to: undefined
  },
  selectedFromAccount: undefined,
  selectedToAccount: undefined
};

export const AccountSelectionContext = createContext<{
  state: AccountSelectionState;
  dispatch: Dispatch<any>;
}>({
  state: initialState,
  dispatch: () => {}
});

export const AccountSelectionProvider: FC<{ children: ReactNode }> = ({
  children
}) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const values = useMemo(
    () => ({
      state,
      dispatch
    }),
    [state, dispatch]
  );

  return (
    <AccountSelectionContext.Provider value={values}>
      {children}
    </AccountSelectionContext.Provider>
  );
};
